// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* App sidebar — primary navigation rail. Token-driven so it follows theme + mode. */
.app-sidebar {
  position: sticky;
  top: 0;
  align-self: flex-start;
  height: 100vh;
  width: 232px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: var(--space-xs);
  padding: var(--space-sm);
  background: var(--glass-bg-strong);
  border-right: 1px solid var(--glass-border);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
  overflow-y: auto;
  transition: width var(--transition-base);
  z-index: var(--z-sticky);
}

.app-sidebar-collapsed {
  width: 64px;
}

/* Brand / collapse control */
.sb-brand {
  display: flex;
  align-items: center;
  gap: var(--space-sm);
  padding: var(--space-xs) var(--space-sm);
  margin-bottom: var(--space-xs);
}

.sb-collapse-btn {
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  border: none;
  border-radius: var(--radius-md);
  background: var(--glass-bg);
  color: var(--color-white);
  font-size: 1.1rem;
  cursor: pointer;
  transition: background var(--transition-fast);
}
/* Hover effects only on devices with a real pointer, so a tap on a
   touch screen does not leave the element stuck in its hover state. */
@media (hover: hover) {
  .sb-collapse-btn:hover {
    background: var(--glass-bg-strong);
  }
}


.sb-brand-name {
  font-family: var(--font-display);
  font-weight: var(--font-weight-bold);
  font-size: var(--font-size-base);
  color: var(--color-white);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Date-gen balance pill. Hidden by default — the TopBar already shows it on
   wider screens; it only appears inside the mobile drawer (see media query),
   where the TopBar pill is hidden to keep the menu button tappable. */
.sb-date-gens {
  display: none;
  align-items: center;
  gap: 4px;
  margin: 0 var(--space-sm) var(--space-xs);
  padding: 8px 12px;
  background: var(--glass-bg);
  border: 1px solid var(--glass-border);
  border-radius: var(--radius-md);
  color: var(--color-white);
  font-size: var(--font-size-sm);
  white-space: nowrap;
}

.sb-date-gens-bonus {
  color: #a855f7;
  font-weight: var(--font-weight-semibold);
}

.app-sidebar-collapsed .sb-brand-name,
.app-sidebar-collapsed .sb-label,
.app-sidebar-collapsed .sb-staff-caret {
  display: none;
}

.app-sidebar-collapsed .sb-item,
.app-sidebar-collapsed .sb-staff-toggle {
  justify-content: center;
}

/* Collapsed rail: the label is hidden so an inline count badge would sit beside
   the centred icon and overflow the 64px rail (clipped at the edge). Float it
   over the icon's top-right corner instead, like a notification pip. */
.app-sidebar-collapsed .sb-badge {
  position: absolute;
  top: 4px;
  right: 4px;
}

/* Nav items */
.sb-nav {
  display: flex;
  flex-direction: column;
  gap: var(--space-xs);
}

.sb-item,
.sb-staff-toggle {
  position: relative;
  display: flex;
  align-items: center;
  gap: var(--space-sm);
  width: 100%;
  padding: var(--space-sm) var(--space-md);
  background: transparent;
  border: 1px solid transparent;
  border-radius: var(--radius-md);
  color: var(--color-white);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  font-family: var(--font-family);
  cursor: pointer;
  text-align: left;
  transition: background var(--transition-fast), border-color var(--transition-fast);
  white-space: nowrap;
}
/* Hover effects only on devices with a real pointer, so a tap on a
   touch screen does not leave the element stuck in its hover state. */
@media (hover: hover) {
  .sb-item:hover,
  .sb-staff-toggle:hover {
    background: var(--glass-bg);
    border-color: var(--glass-border);
  }
}


.sb-item-active {
  background: var(--gradient-primary);
  border-color: var(--glass-border-strong);
  box-shadow: var(--shadow-glow);
}

.sb-icon {
  font-size: var(--font-size-lg);
  width: 1.4em;
  text-align: center;
  flex-shrink: 0;
}

/* Boosters reuses Collection's 🎴 glyph, which made the two nav entries look
   identical. Rotate the card's red hue to green so they read apart. */
.sb-icon-booster {
  filter: hue-rotate(105deg) saturate(1.2);
}

.sb-label {
  flex: 1 1;
  overflow: hidden;
  text-overflow: ellipsis;
}

.sb-badge {
  flex-shrink: 0;
}

/* Staff group */
.sb-staff {
  margin-top: var(--space-sm);
  padding-top: var(--space-sm);
  border-top: 1px solid var(--glass-border);
}

.sb-staff-caret {
  font-size: 0.7rem;
  opacity: 0.7;
}

.sb-staff-items {
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin-top: 2px;
}

.sb-staff-items[hidden] {
  display: none;
}

.sb-item-staff {
  font-size: var(--font-size-sm);
  opacity: 0.92;
  padding-left: var(--space-md);
}

.app-sidebar-collapsed .sb-item-staff {
  padding-left: var(--space-md);
}

/* Mobile scrim behind the drawer */
.sb-scrim {
  display: none;
}

/* Mobile: sidebar becomes an off-canvas drawer */
@media (max-width: 768px) {
  .app-sidebar {
    position: fixed;
    left: 0;
    top: 0;
    width: 248px;
    transform: translateX(-100%);
    transition: transform var(--transition-base);
    box-shadow: var(--shadow-xl);
  }

  .app-sidebar.app-sidebar-collapsed {
    width: 248px;
  }

  .app-sidebar-mobile-open {
    transform: translateX(0);
  }

  /* Surface the date-gen balance in the drawer (TopBar pill is hidden here). */
  .sb-date-gens {
    display: flex;
  }

  .app-sidebar-collapsed .sb-brand-name,
  .app-sidebar-collapsed .sb-label,
  .app-sidebar-collapsed .sb-staff-caret {
    display: revert;
  }

  /* Mobile drawer is full width with labels shown, so the badge sits inline
     again — undo the collapsed-rail corner float. */
  .app-sidebar-collapsed .sb-badge {
    position: static;
  }

  .sb-scrim {
    display: block;
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: calc(var(--z-sticky) - 1);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/layout/Sidebar.css"],"names":[],"mappings":"AAAA,oFAAoF;AACpF;EACE,gBAAgB;EAChB,MAAM;EACN,sBAAsB;EACtB,aAAa;EACb,YAAY;EACZ,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,wBAAwB;EACxB,kCAAkC;EAClC,2CAA2C;EAC3C,2BAA2B;EAC3B,mCAAmC;EACnC,gBAAgB;EAChB,wCAAwC;EACxC,wBAAwB;AAC1B;;AAEA;EACE,WAAW;AACb;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,wCAAwC;EACxC,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,+BAA+B;EAC/B,2BAA2B;EAC3B,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,6CAA6C;AAC/C;AACA;sEACsE;AACtE;EACE;IACE,kCAAkC;EACpC;AACF;;;AAGA;EACE,gCAAgC;EAChC,oCAAoC;EACpC,gCAAgC;EAChC,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;sEAEsE;AACtE;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yCAAyC;EACzC,iBAAiB;EACjB,2BAA2B;EAC3B,qCAAqC;EACrC,+BAA+B;EAC/B,yBAAyB;EACzB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,wCAAwC;AAC1C;;AAEA;;;EAGE,aAAa;AACf;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;;uEAEuE;AACvE;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;AACZ;;AAEA,cAAc;AACd;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;;EAEE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,WAAW;EACX,wCAAwC;EACxC,uBAAuB;EACvB,6BAA6B;EAC7B,+BAA+B;EAC/B,yBAAyB;EACzB,8BAA8B;EAC9B,wCAAwC;EACxC,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,kFAAkF;EAClF,mBAAmB;AACrB;AACA;sEACsE;AACtE;EACE;;IAEE,2BAA2B;IAC3B,iCAAiC;EACnC;AACF;;;AAGA;EACE,mCAAmC;EACnC,wCAAwC;EACxC,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;sEACsE;AACtE;EACE,wCAAwC;AAC1C;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,8BAA8B;EAC9B,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,mCAAmC;AACnC;EACE,aAAa;AACf;;AAEA,iDAAiD;AACjD;EACE;IACE,eAAe;IACf,OAAO;IACP,MAAM;IACN,YAAY;IACZ,4BAA4B;IAC5B,4CAA4C;IAC5C,4BAA4B;EAC9B;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,wBAAwB;EAC1B;;EAEA,6EAA6E;EAC7E;IACE,aAAa;EACf;;EAEA;;;IAGE,eAAe;EACjB;;EAEA;oDACkD;EAClD;IACE,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,QAAQ;IACR,8BAA8B;IAC9B,kCAAkC;EACpC;AACF","sourcesContent":["/* App sidebar — primary navigation rail. Token-driven so it follows theme + mode. */\n.app-sidebar {\n  position: sticky;\n  top: 0;\n  align-self: flex-start;\n  height: 100vh;\n  width: 232px;\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-xs);\n  padding: var(--space-sm);\n  background: var(--glass-bg-strong);\n  border-right: 1px solid var(--glass-border);\n  backdrop-filter: blur(14px);\n  -webkit-backdrop-filter: blur(14px);\n  overflow-y: auto;\n  transition: width var(--transition-base);\n  z-index: var(--z-sticky);\n}\n\n.app-sidebar-collapsed {\n  width: 64px;\n}\n\n/* Brand / collapse control */\n.sb-brand {\n  display: flex;\n  align-items: center;\n  gap: var(--space-sm);\n  padding: var(--space-xs) var(--space-sm);\n  margin-bottom: var(--space-xs);\n}\n\n.sb-collapse-btn {\n  flex-shrink: 0;\n  width: 36px;\n  height: 36px;\n  border: none;\n  border-radius: var(--radius-md);\n  background: var(--glass-bg);\n  color: var(--color-white);\n  font-size: 1.1rem;\n  cursor: pointer;\n  transition: background var(--transition-fast);\n}\n/* Hover effects only on devices with a real pointer, so a tap on a\n   touch screen does not leave the element stuck in its hover state. */\n@media (hover: hover) {\n  .sb-collapse-btn:hover {\n    background: var(--glass-bg-strong);\n  }\n}\n\n\n.sb-brand-name {\n  font-family: var(--font-display);\n  font-weight: var(--font-weight-bold);\n  font-size: var(--font-size-base);\n  color: var(--color-white);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* Date-gen balance pill. Hidden by default — the TopBar already shows it on\n   wider screens; it only appears inside the mobile drawer (see media query),\n   where the TopBar pill is hidden to keep the menu button tappable. */\n.sb-date-gens {\n  display: none;\n  align-items: center;\n  gap: 4px;\n  margin: 0 var(--space-sm) var(--space-xs);\n  padding: 8px 12px;\n  background: var(--glass-bg);\n  border: 1px solid var(--glass-border);\n  border-radius: var(--radius-md);\n  color: var(--color-white);\n  font-size: var(--font-size-sm);\n  white-space: nowrap;\n}\n\n.sb-date-gens-bonus {\n  color: #a855f7;\n  font-weight: var(--font-weight-semibold);\n}\n\n.app-sidebar-collapsed .sb-brand-name,\n.app-sidebar-collapsed .sb-label,\n.app-sidebar-collapsed .sb-staff-caret {\n  display: none;\n}\n\n.app-sidebar-collapsed .sb-item,\n.app-sidebar-collapsed .sb-staff-toggle {\n  justify-content: center;\n}\n\n/* Collapsed rail: the label is hidden so an inline count badge would sit beside\n   the centred icon and overflow the 64px rail (clipped at the edge). Float it\n   over the icon's top-right corner instead, like a notification pip. */\n.app-sidebar-collapsed .sb-badge {\n  position: absolute;\n  top: 4px;\n  right: 4px;\n}\n\n/* Nav items */\n.sb-nav {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-xs);\n}\n\n.sb-item,\n.sb-staff-toggle {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: var(--space-sm);\n  width: 100%;\n  padding: var(--space-sm) var(--space-md);\n  background: transparent;\n  border: 1px solid transparent;\n  border-radius: var(--radius-md);\n  color: var(--color-white);\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-semibold);\n  font-family: var(--font-family);\n  cursor: pointer;\n  text-align: left;\n  transition: background var(--transition-fast), border-color var(--transition-fast);\n  white-space: nowrap;\n}\n/* Hover effects only on devices with a real pointer, so a tap on a\n   touch screen does not leave the element stuck in its hover state. */\n@media (hover: hover) {\n  .sb-item:hover,\n  .sb-staff-toggle:hover {\n    background: var(--glass-bg);\n    border-color: var(--glass-border);\n  }\n}\n\n\n.sb-item-active {\n  background: var(--gradient-primary);\n  border-color: var(--glass-border-strong);\n  box-shadow: var(--shadow-glow);\n}\n\n.sb-icon {\n  font-size: var(--font-size-lg);\n  width: 1.4em;\n  text-align: center;\n  flex-shrink: 0;\n}\n\n/* Boosters reuses Collection's 🎴 glyph, which made the two nav entries look\n   identical. Rotate the card's red hue to green so they read apart. */\n.sb-icon-booster {\n  filter: hue-rotate(105deg) saturate(1.2);\n}\n\n.sb-label {\n  flex: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.sb-badge {\n  flex-shrink: 0;\n}\n\n/* Staff group */\n.sb-staff {\n  margin-top: var(--space-sm);\n  padding-top: var(--space-sm);\n  border-top: 1px solid var(--glass-border);\n}\n\n.sb-staff-caret {\n  font-size: 0.7rem;\n  opacity: 0.7;\n}\n\n.sb-staff-items {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  margin-top: 2px;\n}\n\n.sb-staff-items[hidden] {\n  display: none;\n}\n\n.sb-item-staff {\n  font-size: var(--font-size-sm);\n  opacity: 0.92;\n  padding-left: var(--space-md);\n}\n\n.app-sidebar-collapsed .sb-item-staff {\n  padding-left: var(--space-md);\n}\n\n/* Mobile scrim behind the drawer */\n.sb-scrim {\n  display: none;\n}\n\n/* Mobile: sidebar becomes an off-canvas drawer */\n@media (max-width: 768px) {\n  .app-sidebar {\n    position: fixed;\n    left: 0;\n    top: 0;\n    width: 248px;\n    transform: translateX(-100%);\n    transition: transform var(--transition-base);\n    box-shadow: var(--shadow-xl);\n  }\n\n  .app-sidebar.app-sidebar-collapsed {\n    width: 248px;\n  }\n\n  .app-sidebar-mobile-open {\n    transform: translateX(0);\n  }\n\n  /* Surface the date-gen balance in the drawer (TopBar pill is hidden here). */\n  .sb-date-gens {\n    display: flex;\n  }\n\n  .app-sidebar-collapsed .sb-brand-name,\n  .app-sidebar-collapsed .sb-label,\n  .app-sidebar-collapsed .sb-staff-caret {\n    display: revert;\n  }\n\n  /* Mobile drawer is full width with labels shown, so the badge sits inline\n     again — undo the collapsed-rail corner float. */\n  .app-sidebar-collapsed .sb-badge {\n    position: static;\n  }\n\n  .sb-scrim {\n    display: block;\n    position: fixed;\n    inset: 0;\n    background: rgba(0, 0, 0, 0.5);\n    z-index: calc(var(--z-sticky) - 1);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
